exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help-team-members-page{display:flex;flex-direction:column;height:calc(100vh - 194px);min-height:0;overflow:hidden}.help-content-scroll{flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;padding:8px 8px 0}.help-content-body h3{margin-bottom:10px;margin-top:15px;text-decoration:underline}.help-content-body li{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/account.management/help/help.team-members.component.css
// module id = 1154
// module chunks = 0